export default __webpack_public_path__ + "static/media/pratik.71a8ab02.png";